// import React, { Component, useState, useEffect, useMemo } from "react";
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { generateBrydgeICallData, getCurrentWalletConnected } from '../../utils/interact.js';
// import { Container } from "../../formContainer";
// import LoadingIcons from "react-loading-icons";
import ReactRoundedImage from 'react-rounded-image';
import atkLogo from '../../assets/atk-logo.jpg';
// import cx from "classnames";
import { BrydgeWidget } from '@brydge-network/widget';

const dummyCalls = [
  {
    _to: '0x0000000000000000000000000000000000000000',
    _value: 0,
    _calldata: '0x00000000000000000',
  },
];

function TopSellersItem({ rank, img, title, price }) {

  const [address, setAddress] = useState('0x0');
  const [provider, setProvider] = useState(null);
  const [callData, setCallData] = useState(dummyCalls);
  const [count, setCount] = useState(1);
  const [displayWidget, setDisplayWidget] = useState(0);

  function updateCount(num) {
    let newCount = count + num;
    if (newCount > 0 && newCount <= (rank == 1 ? 30 : rank == 2 ? 10 : 5)) {
      setCount(newCount);
      setCallData(generateBrydgeICallData(price, rank, count, address));
    }
  }
  function showWidget(num) {
    console.log('num', num);
    setDisplayWidget(num);
    console.log(displayWidget);
  }

  useEffect(async () => {
    const { address, provider } = await getCurrentWalletConnected();
    setAddress(address);
    setProvider(provider);
    setCallData(generateBrydgeICallData(price, rank, count, address));
  }, [address, provider]);

  return (
    <div>
      <div id='' className='author-item' >
        <div className='author-img'>
          <img src={img} width='120' alt='' />
          <a className='btn pl-0'></a>
        </div>
        <div className='author-info' style={{marginTop: '20px'}}>
          <h5 className='author-name'>{title}</h5>

          <div className='dynamic-margin'>
            <div
              style={{
                display: 'flex',
                flexWrap: 'nowrap',
                flexDirection: 'row',
              }}
            >
              <p className='author-earn mb-0' style={{ marginRight: '10px' }}>
                {' '}
                {price} ATK{' '}
              </p>
              <ReactRoundedImage image={atkLogo} imageWidth='20' imageHeight='20' roundedSize='60' />
            </div>
          </div>

          <div className='App'>
            <div style={{ color: 'white' }}>Count: {count}</div>
            <button className='count-btn mr-3' onClick={() => updateCount(1)}>+</button>
            <button className='count-btn mr-3' onClick={() => updateCount(-1)}>-</button>
          </div>
        </div>
      </div>
      <div align='center'>
        {displayWidget === 0 ? (
          <button style={{marginBottom: '20px'}} className='count-btn mr-3' onClick={() => showWidget(1)}>Mint {count} {title} Land</button>
        ) : (
          <BrydgeWidget
            jsonRpcEndpoints={{
              1: `https://mainnet.infura.io/v3/217a32ac04b543c688bf5c3deffa6826`,
              137: `https://polygon-mainnet.infura.io/v3/217a32ac04b543c688bf5c3deffa6826`,
            }}
            calls={callData}
            provider={provider}
            outputTokenAddress='0xF868939Ee81F04f463010BC52EAb91c0839eF08c'
            price={price * count}
            title={`Mint ${count} ${title} Land`}
            destinationChainId={137}
            collectionAddress={'0x7D792e98bd1Efe92dA70E4658f7C541aC22F09a2'}
            tokenId={1}
            theme={'darkTheme'}
            darkMode={true}
          />
        )}
      </div>
    </div>
  );
}

export default TopSellersItem;
